var React = require('react');

function Brackets (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M0,0H31.735V8.837H9.962V65.879H31.735v8.838H0Z","fill":"#FFFFFF","key":0}),React.createElement("path",{"d":"M81.545,74.717H49.81V65.879H71.583V8.837H49.81V0H81.545Z","fill":"#FFFFFF","key":1})]));
}

Brackets.defaultProps = {"width":"81.545","height":"74.717","viewBox":"0 0 81.545 74.717"};

module.exports = Brackets;

Brackets.default = Brackets;
